import BaseItem, { Rarity } from './base_item';

export default class GunTerminal extends BaseItem {
    constructor(x, y) {
        super(x, y, "items", "cryopod.png");
    }

    //this is width/height of collision box (attached to bottom)
    static get width() { return 15; }
    static get height() { return 8; }

    static get mass() { return 5; }
    static get electronic() { return true; }
    static get rarity() { return Rarity.RARE; }


    static get type() { return 'cryopod' }
    static get label() { return 'Empty cryopod' }
    static get description() {
        return `It's a cryopod, your last hope for survival. You hide your ice cream from Jenkins there.`
    }
}


// WEBPACK FOOTER //
// ./src/objects/items/cryopod.js